import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-questions-container-side',
  template: '<ng-content ></ng-content>',
  styles: [''],
  encapsulation: ViewEncapsulation.None,
})
export class QuestionsContainerSideComponent {}
